import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminApi } from "../../utils/axiosConfig";

export default function AdminRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    async function checkAuth() {
      try {
        const res = await adminApi.get(`/api/admin/me`);
        if (res.data.success) {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }
      } catch {
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    }
    checkAuth();
  }, []);

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "Georgia, serif",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "60px",
            height: "60px",
            marginBottom: "1rem",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "3px solid transparent",
              borderTop: "3px solid #4299e1",
              borderRadius: "50%",
              animation: "spin 1.5s linear infinite",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "3px solid transparent",
              borderRight: "3px solid #38b2ac",
              borderRadius: "50%",
              animation: "spin 1.5s linear infinite",
              animationDelay: "0.5s",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "3px solid transparent",
              borderBottom: "3px solid #ed8936",
              borderRadius: "50%",
              animation: "spin 1.5s linear infinite",
              animationDelay: "1s",
            }}
          ></div>
        </div>
        <p
          style={{
            color: "#4a5568",
            fontSize: "1rem",
            fontWeight: "500",
            margin: "0",
          }}
        >
          Chargement en cours...
        </p>
      </div>
    );

  if (!authenticated) {
    return <Navigate to="/admin/login" />;
  }

  return children;
}
